import { type SelectFieldOption } from '@hrlogics/react-helper-types';

import { type SimpleObject } from '@clearverify/types';

export const selectOptionsToValuesArray = (
  options: SelectFieldOption[],
  enumObj?: Record<string | number, string>,
) => {
  return options.map(option => {
    return enumObj ? enumObj[option.value] : option.value;
  });
};

export const enumToSelectOptions = <T extends SimpleObject<string>, V = T[keyof T]>(
  enumObject: T,
  labelMap?: Record<string, string>,
): SelectFieldOption<V>[] => {
  return Object.entries(enumObject).map(entry => {
    const [label, value] = entry;
    return { value: value as V, label: labelMap?.[value] ?? label };
  });
};
